import { render } from "./RaceEvent.vue?vue&type=template&id=4a3cf532"
import script from "./RaceEvent.vue?vue&type=script&lang=js"
export * from "./RaceEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__